export default __webpack_public_path__ + "static/media/home-finance-about-img-01.ccad1b03.jpg";